module.exports = __webpack_public_path__ + "img/search-job2.8c13864c.png";